import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {IExcDataFilter, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgFilterComponent} from '../exg-filter/exg-filter.component';

@Component({
  selector: 'app-exg-filter-chips',
  templateUrl: './exg-filter-chips.component.html',
  changeDetection: ChangeDetectionStrategy.Default
})
export class ExgFilterChipsComponent extends ExcTranslation implements OnInit {
  @Input()
  inputDataTable = {} as any;
  @Input()
  VCFilterControl!: {VCFilter: ExgFilterComponent, VCSearch: ExgFilterComponent, VCSort: ExgFilterComponent};
  /*********************************/
  @ViewChild('VCcasePagerFilterControl', { read: ExgFilterComponent })
  VCPagerFilterControl!: ExgFilterComponent;
  /*********************************/

  workspace = {
    activFilter: [] as any[],
    MetaInfo: {
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter
    } as IExcMetaInfo as any,
    computeMetaInfo: (MetaInfo: IExcMetaInfo): void => {
      this.workspace.activFilter = [];
      if (MetaInfo) {
        this.workspace.MetaInfo = MetaInfo;
        this.controller.computeActiveFilter(this.workspace.MetaInfo.dataFilter);
      }
    }
  };
  /*********************************/
  controller: {
    uiSortAktiv: () => any[],
    uiFilterAktiv: (filterType?: number) => any[],
    uiFilterActivApplied: (sStart?: number, sEnd?: number, fType?: (1 | 2)) => any[],
    chipClose_resetFilter: ($event: { item: any }) => void,
    computeActiveFilter: (dataFilter: IExcDataFilter) => void,
  } = {
    uiSortAktiv: (): any[] => {
      return this.inputDataTable.uiSort.filter(
        (sort: any) => sort.uiValue !== 0
      );
    },
    uiFilterAktiv: (filterType?: number): any[] => {
      return this.workspace.activFilter
        .filter(
          (filters: any) =>
            !filterType || (filterType && filterType === filters.filterType)
        );
    },
    uiFilterActivApplied: (
      sStart?: number,
      sEnd = this.controller.uiFilterAktiv().length,
      fType?: 1 | 2
    ): any[] => {
      return this.controller.uiFilterAktiv()
        .reverse()
        .slice(sStart ? sStart : 0, sEnd ? sEnd : this.controller.uiFilterAktiv().length)
        .filter(
          (filter: any) => (filter.filterType === fType && fType) || !fType
        );
    },
    computeActiveFilter: (dataFilter = this.workspace.MetaInfo.dataFilter): void => {
      if (dataFilter) {
        this.inputDataTable.uiFilter
          .filter((filters: any) => ((filters.uiValue === true && filters.filterType === 1) ||
            (filters.filterCondition.value.length > 0 && filters.filterCondition.value !== '' &&
              filters.filterType === 2)))
          .forEach((filter: any) => {
            filter.applied =  (dataFilter && dataFilter[filter.filterField])
              && ((
                JSON.stringify(dataFilter[filter.filterField]).includes(filter.filterIdent)
                &&
                filter.filterType === 1
              ) || (filter.filterType === 2 && ExcCoreModule.Array.GetAll(dataFilter[filter.filterField])[0]['value'].length > 0));

            filter.chipUiCaption =
              filter.filterType === 1
                ? filter.uiCaption
                : `${filter.uiCaption}-\"${filter.filterCondition.value}\"`;

            if (filter.applied) {
              this.workspace.activFilter.push(filter);
            }
          });
      }
    },

    chipClose_resetFilter: ($event): void => {
      if (this.inputDataTable.isLoading) {
        return;
      }
      if ($event.item.filterType === 1) {
        $event.item.uiValue = !$event.item.uiValue;
      }
      if ($event.item.filterType === 2) {
        $event.item.filterCondition.value = '';
        $event.item.uiValue = !$event.item.uiValue;
      }
      this.VCFilterControl.VCFilter.ApplyFilter();
      this.inputDataTable.loadData();
    },
  };
  /*********************************/
  constructor(
    private chDecRef: ChangeDetectorRef,
    public enumSvc: EnumerationService,
    public appSrv: ApplicationService
  ) {
    super();
    setInterval(() => {
      this.chDecRef.markForCheck();
    }, 200);
  }

  ngOnInit(): void {
    this.registerEvents();
  }

  registerEvents(): void {
    // this.VCFilterControl.VCFilter.onActivateFilterEmitter.subscribe((MetaInfo: IExcMetaInfo) => {
    //   this.workspace.computeMetaInfo(JSON.parse(JSON.stringify(MetaInfo)));
    // });
    // this.VCFilterControl.VCSearch
    //   .onActivateFilterEmitter.subscribe((MetaInfo: IExcMetaInfo) => {
    //     this.workspace.computeMetaInfo(JSON.parse(JSON.stringify(MetaInfo)));
    // });
    // this.VCFilterControl.VCSort.onActivateFilterEmitter.subscribe((MetaInfo: IExcMetaInfo) => {
    //   this.workspace.computeMetaInfo(JSON.parse(JSON.stringify(MetaInfo)));
    // });
  }
}
